import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
    { path: '/', component: loadComponent('Home/Index'), name: 'home' },
    { path: '/decline/:email', component: loadComponent('Decline/Index'), name: 'decline' },
    { path: '/unsubscribe/:email', component: loadComponent('Unsubscribe/Index'), name: 'unsubscribe' },
]

function loadComponent(view) {
    return() => import(`../pages/${view}.vue`)
}

export default new VueRouter({
    mode: 'history',
    base: '/',
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes
})
